const STORAGE_KEY = 'portal.guestSession.v1'

function emptyGuest() {
  return {
    activo: false,
    tdId: null,
    nroDoc: '',
    tipoDocLabel: '',
    fechaNacimiento: '',
    sexo: '',
    nombre: '',
    apellido: '',
    email: '',
    celular: '',
    telefono: '',
    sinFichaAutogestion: false,
    accessToken: '',
    sessionId: '',
    fichaId: null,
  }
}

function readFromStorage() {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) return emptyGuest()
    const raw = window.sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return emptyGuest()
    const parsed = JSON.parse(raw)
    return { ...emptyGuest(), ...parsed }
  } catch {
    return emptyGuest()
  }
}

export { STORAGE_KEY, emptyGuest, readFromStorage }
export default () => readFromStorage()
